/** The lines the landing's narrator has recordings of (#949). */
export type NarratorLine = "letter" | "mafia" | "toast";

/**
 * The locales a recording exists for: every one the catalogue carries, as
 * `scripts/landing-narrator-clips.mjs` made them. Anything else hears English.
 */
const RECORDED = [
  "ar",
  "bn",
  "en",
  "es",
  "fr",
  "hi",
  "id",
  "ru",
  "ur",
  "zh-CN",
];

/** Where a line's recording is, in the visitor's language when there is one. */
export const narratorClip = (
  language: string | undefined,
  line: NarratorLine,
) => {
  const exact = RECORDED.find((code) => code === language);
  const base = RECORDED.find((code) => code === language?.split("-")[0]);
  return `/landing/narrator/${exact ?? base ?? "en"}/${line}.mp3`;
};
